import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RoomActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Hospitality/Room/RoomBrowser")
    }

    render() {
        return (
            <Activity 
                name="Room"
                context="Room"
                RenderedComponent={this.RenderedComponent}
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(RoomActivity)
